import HttpWrapper from '@utils/http/httpWrapper'
import ShipbobAppSettings from '../../appSettings/appSetting'
import toastr from 'toastr'

export const MERCHANT_PRICING_API = ShipbobAppSettings.MerchantPricingApi.ApiBaseUrl
export const PUBLIC_LOCATION_API = ShipbobAppSettings.ShipBobPublicLocationsApiBaseUrl

class NetworksServiceInternal {
  urls () {
    return {
      getUserPlans: MERCHANT_PRICING_API + 'userplan/allPlans',
      getMerchantFCs: PUBLIC_LOCATION_API + '/api/FulfillmentCenter/3',
      getMerchantPricingRegionsByFCs: MERCHANT_PRICING_API + 'PricingRegion/GetPricingRegionsByFC',
      getAssignablePlans: MERCHANT_PRICING_API + 'plan/assignableplans',
      saveUserPlan: MERCHANT_PRICING_API + 'plan/userplan',
      getAllPlans: MERCHANT_PRICING_API + 'plan'
    }
  }

  handleGetUserPlansError () {
    toastr.error('Unable to retrieve any user plans.')
  }

  handleGetAllPlansError () {
    toastr.error('Unable to retrieve all plans.')
  }

  handleMerchantFCsError () {
    toastr.error('Unable to retrieve merchant fulfillment centers.')
  }

  handleUnableToSavePlansError () {
    toastr.error('Some error occured. Unable to update User Plan.')
  }

  handlePricingRegionsError () {
    toastr.error('Some error occured. Unable to get merchant Pricing Regions.')
  }

  async getUserPlans () {
    const request = {
      Url: `${this.urls().getUserPlans}`
    }

    return await HttpWrapper.Get(request, undefined, this.handleGetUserPlansError, true)
  }

  async getMerchantFCs () {
    const request = {
      Url: `${this.urls().getMerchantFCs}`
    }

    return await HttpWrapper.Get(request, undefined, this.handleMerchantFCsError, true)
  }

  async getMerchantPricingRegionsByFCs (payload) {
    const request = {
      Url: `${this.urls().getMerchantPricingRegionsByFCs}`,
      Data: payload
    }

    return await HttpWrapper.Post(request, undefined, this.handlePricingRegionsError, true)
  }

  async getAssignablePlans () {
    const request = {
      Url: `${this.urls().getAssignablePlans}`
    }

    return await HttpWrapper.Get(request, undefined, this.handleGetUserPlansError, true)
  }

  async getAssignablePlansByCurrency (currencyCode) {
    const request = {
      Url: `${this.urls().getAssignablePlans}/${currencyCode}`
    }

    return await HttpWrapper.Get(request, undefined, this.handleGetUserPlansError, true)
  }

  async SaveUserPlan (payload) {
    const request = {
      Url: `${this.urls().saveUserPlan}`,
      Data: payload
    }

    return await HttpWrapper.Post(request, undefined, this.handleUnableToSavePlansError, true)
  }

  async getAllPlans () {
    const request = {
      Url: `${this.urls().getAllPlans}`
    }
    return await HttpWrapper.Get(request, undefined, this.handleGetAllPlansError, true)
  }
}

export const NetworksService = new NetworksServiceInternal()
